import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { MediaService } from "src/app/core/services/media.service";
import { PermissionService } from "src/app/core/services/permision.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomBlogComponent } from "../../ui-elements/custom-blog/custom-blog.component";

@Component({
  selector: "app-blog-categories",
  templateUrl: "./blog-categories.component.html",
  styleUrls: ["./blog-categories.component.scss"],
})
export class BlogCategoriesComponent {
  blogCategoryForm: FormGroup;
  isUpdating = false;
  hasChanges = false;
  isSubmitted = false;
  deletedCategories = [];
  constructor(
    private fb: FormBuilder,
    private api: MediaService,
    public permission: PermissionService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}
  ngOnInit() {
    this.resetForm();
    this.getblogCategory();
  }

  resetForm() {
    this.blogCategoryForm = this.fb.group({
      blog: this.fb.array([
        this.fb.group({
          is_new: [""],
          id: ["", [Validators.required]],
          blog_category: ["", [Validators.required]],
          is_updated: [""],
          is_deleted: [""],
          priority: [0, [Validators.required]],
        }),
      ]),
    });
  }

  getblogCategory() {
    this.api.getBlogCategory().subscribe((result: any) => {
      this.blogCategoryForm = this.fb.group({
        blog: new FormArray([]),
      });
      result?.category_data.forEach((ao, i) => {
        (this.blogCategoryForm.get("blog") as FormArray).push(
          this.fb.group({
            id: [ao?.id, [Validators.required]],
            is_new: [""],
            blog_category: [ao?.blog_category, [Validators.required]],
            is_deleted: [""],
            priority: [i, [Validators.required]],
            is_updated: [false],
          })
        );
        this.deletedCategories = [];
      });
    });
  }

  blogCategory(): FormArray {
    return this.blogCategoryForm.get("blog") as FormArray;
  }

  newBlog(): FormGroup {
    return this.fb.group({
      id: [""], // Leave blank for new entries
      blog_category: ["", [Validators.required]],
      is_new: [true],
      is_updated: [false],
      is_deleted: [false],
      priority: [0, [Validators.required]],
    });
  }

  addCategory() {
    this.blogCategory().push(this.newBlog());
  }

  dataChanged(i) {
    this.blogCategoryForm.value.blog[i].is_updated = true;
  }

  removeCategory(i: number) {
    this.isSubmitted = false;
    const control = this.blogCategoryForm.value.blog[i];
    control.is_deleted = true;
    if (control.hasOwnProperty("id")) {
      this.deletedCategories.push(control);
    }
    this.blogCategory().removeAt(i);
  }

  onSubmit(form: FormGroup) {
    if (form.valid) {
      this.isUpdating = true;

      this.deletedCategories.forEach((deleted) => {
        deleted.is_updated = false;
        form.value.blog.push(deleted);
      });

      const payload = {
        category_data: form.value.blog.map((item: any) => {
          const obj: any = {
            blog_category: item.blog_category,
          };

          if (item.id) obj.id = item.id;

          if (item.is_new) {
            obj.is_new = true;
          } else if (item.is_updated) {
            obj.is_updated = true;
          }

          if (item.is_deleted) obj.is_deleted = true;

          return obj;
        }),
      };

      this.api.setUsCategory(payload).subscribe(
        () => {
          this.toastr.success("Content Updated Successfully!");
          this.getblogCategory();
          this.hasChanges = false;
          this.isUpdating = false;
        },
        () => {
          this.isUpdating = false;
        }
      );
    } else {
      this.isSubmitted = true;
      this.toastr.warning("Fill all fields and Save!");
    }
  }

  checkPermission(type) {
    return this.permission.hasPermission(type);
  }

  showSortModal(data, label) {
    let data_card: any = {
      list: data,
      label: label,
      api_url: "cms-admin/testimonial/testimonial-priority/position",
    };
    const modalRef = this.modalService.open(CustomBlogComponent, {
      size: "md",
      scrollable: true,
      windowClass: "modal-big-lg",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.sortData = data_card;
    modalRef.result.then((result) => {
      if (result) this.getblogCategory();
    });
  }
}
